import ace from 'ace-builds';

import modeJsonUrl from 'ace-builds/src-noconflict/mode-json?url';

ace.config.setModuleUrl('ace/mode/json', modeJsonUrl);

import modeJavascriptUrl from 'ace-builds/src-noconflict/mode-javascript?url';

ace.config.setModuleUrl('ace/mode/javascript', modeJavascriptUrl);

import modeJavaUrl from 'ace-builds/src-noconflict/mode-java?url';

ace.config.setModuleUrl('ace/mode/java', modeJavaUrl);

import modePythonUrl from 'ace-builds/src-noconflict/mode-python?url';

ace.config.setModuleUrl('ace/mode/python', modePythonUrl);
ace.config.setModuleUrl('ace/mode/python2', modePythonUrl);
ace.config.setModuleUrl('ace/mode/python3', modePythonUrl);

import modeCCppUrl from 'ace-builds/src-noconflict/mode-c_cpp?url';

ace.config.setModuleUrl('ace/mode/c', modeCCppUrl);
ace.config.setModuleUrl('ace/mode/cpp', modeCCppUrl);
ace.config.setModuleUrl('ace/mode/c_cpp', modeCCppUrl);

import modeCsharpUrl from 'ace-builds/src-noconflict/mode-csharp?url';

ace.config.setModuleUrl('ace/mode/csharp', modeCsharpUrl);

import modePhpUrl from 'ace-builds/src-noconflict/mode-php?url';

ace.config.setModuleUrl('ace/mode/php', modePhpUrl);

import modeCssUrl from 'ace-builds/src-noconflict/mode-css?url';

ace.config.setModuleUrl('ace/mode/css', modeCssUrl);

import modeSqlUrl from 'ace-builds/src-noconflict/mode-sql?url';

ace.config.setModuleUrl('ace/mode/sql', modeSqlUrl);

import modeHtmlUrl from 'ace-builds/src-noconflict/mode-html?url';

ace.config.setModuleUrl('ace/mode/html', modeHtmlUrl);

import modeYamlUrl from 'ace-builds/src-noconflict/mode-yaml?url';

ace.config.setModuleUrl('ace/mode/yaml', modeYamlUrl);

import themeGithubUrl from 'ace-builds/src-noconflict/theme-github?url';

ace.config.setModuleUrl('ace/theme/github', themeGithubUrl);

import themeDraculaUrl from 'ace-builds/src-noconflict/theme-dracula?url';

ace.config.setModuleUrl('ace/theme/dracula', themeDraculaUrl);

import themeChromeUrl from 'ace-builds/src-noconflict/theme-chrome?url';

ace.config.setModuleUrl('ace/theme/chrome', themeChromeUrl);

import themeXcodeUrl from 'ace-builds/src-noconflict/theme-xcode?url';

ace.config.setModuleUrl('ace/theme/xcode', themeXcodeUrl);

import themeMonokaiUrl from 'ace-builds/src-noconflict/theme-monokai?url';

ace.config.setModuleUrl('ace/theme/monokai', themeMonokaiUrl);

import workerBaseUrl from 'ace-builds/src-noconflict/worker-base?url';

ace.config.setModuleUrl('ace/mode/base', workerBaseUrl);

import workerJsonUrl from 'ace-builds/src-noconflict/worker-json?url';

ace.config.setModuleUrl('ace/mode/json_worker', workerJsonUrl);

import workerJavascriptUrl from 'ace-builds/src-noconflict/worker-javascript?url';

ace.config.setModuleUrl('ace/mode/javascript_worker', workerJavascriptUrl);

import workerPhpUrl from 'ace-builds/src-noconflict/worker-php?url';

ace.config.setModuleUrl('ace/mode/php_worker', workerPhpUrl);

import workerCssUrl from 'ace-builds/src-noconflict/worker-css?url';

ace.config.setModuleUrl('ace/mode/css_worker', workerCssUrl);

import workerHtmlUrl from 'ace-builds/src-noconflict/worker-html?url';

ace.config.setModuleUrl('ace/mode/html_worker', workerHtmlUrl);

import workerYamlUrl from 'ace-builds/src-noconflict/worker-yaml?url';

ace.config.setModuleUrl('ace/mode/yaml_worker', workerYamlUrl);

import snippetsHtmlUrl from 'ace-builds/src-noconflict/snippets/html?url';

ace.config.setModuleUrl('ace/snippets/html', snippetsHtmlUrl);

import snippetsJsUrl from 'ace-builds/src-noconflict/snippets/javascript?url';

ace.config.setModuleUrl('ace/snippets/javascript', snippetsJsUrl);

import snippetsPythonUrl from 'ace-builds/src-noconflict/snippets/python?url';

ace.config.setModuleUrl('ace/snippets/python', snippetsPythonUrl);
ace.config.setModuleUrl('ace/snippets/python2', snippetsPythonUrl);
ace.config.setModuleUrl('ace/snippets/python3', snippetsPythonUrl);

import snippetsCCppUrl from 'ace-builds/src-noconflict/snippets/c_cpp?url';

ace.config.setModuleUrl('ace/snippets/c', snippetsCCppUrl);
ace.config.setModuleUrl('ace/snippets/cpp', snippetsCCppUrl);
ace.config.setModuleUrl('ace/snippets/c_cpp', snippetsCCppUrl);

import snippetsPhpUrl from 'ace-builds/src-noconflict/snippets/php?url';

ace.config.setModuleUrl('ace/snippets/php', snippetsPhpUrl);

import snippetsCssUrl from 'ace-builds/src-noconflict/snippets/css?url';

ace.config.setModuleUrl('ace/snippets/css', snippetsCssUrl);

import snippetsJavaUrl from 'ace-builds/src-noconflict/snippets/java?url';

ace.config.setModuleUrl('ace/snippets/java', snippetsJavaUrl);

import snippetsYamlUrl from 'ace-builds/src-noconflict/snippets/yaml?url';

ace.config.setModuleUrl('ace/snippets/javascript', snippetsYamlUrl);

import snippetsJsonUrl from 'ace-builds/src-noconflict/snippets/json?url';

ace.config.setModuleUrl('ace/snippets/json', snippetsJsonUrl);

import 'ace-builds/src-noconflict/ext-language_tools';

ace.require("ace/ext/language_tools");